import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IntegrationIndeed } from '@app/models/company/settings/integrations/indeed.model';

@Component({
    selector: 'app-quick-apply-card',
    templateUrl: './indeed-quick-apply-card.template.html',
    styleUrls: ['./indeed-quick-apply-card.style.scss'],
})
export class IndeedQuickApplyCardComponent {
    @Input() integrationIndeed: IntegrationIndeed;
    @Output() integrationIndeedChange: EventEmitter<IntegrationIndeed> = new EventEmitter<IntegrationIndeed>();
}
